// Mock data for HALALGIFHAMPERS - frontend only
// TODO: replace with real API calls to backend once available

export const BRAND = {
  name: "HALALGIFHAMPERS",
  tagline: "Premium Halal Gift Hampers",
  uen: "53527129L",
  address: "50 Bukit Batok Street 23 #07-01 Midview Building, Singapore 659578",
  phone: "+65 9711 6002",
  phoneRaw: "6597116002",
  email: "hello@halalgifhampers.com",
  whatsapp: "https://wa.me/6597116002",
  // Served from frontend/public — no external CDN dependency. Transparent PNG.
  logo: "/logo.png",
  logoWhite: "/logo.png",
  domain: "halalgifhampers.com",
};

export const waLink = (text) =>
  `${BRAND.whatsapp}${text ? `?text=${encodeURIComponent(text)}` : ""}`;

export const CATEGORIES = [
  {
    slug: "wedding",
    name: "Wedding Hampers",
    tagline: "Timeless gifts for beautiful unions",
    description:
      "Elegant halal gift hampers curated for weddings — celebrate love with premium chocolates, dates, dry fruits and luxurious keepsakes.",
    image: "https://images.unsplash.com/photo-1674620213535-9b2a2553ef40?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHx3ZWRkaW5nJTIwZ2lmdCUyMGVsZWdhbnR8ZW58MHx8fHwxNzgyOTAzOTE4fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "newborn",
    name: "Newborn Hampers",
    tagline: "Warm welcomes for little blessings",
    description:
      "Halal-friendly newborn gift hampers with soft essentials, gentle treats and thoughtful keepsakes for new parents and babies.",
    image: "https://images.unsplash.com/photo-1559454403-b8fb88521f11?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwyfHxuZXdib3JuJTIwYmFieSUyMGdpZnQlMjBiYXNrZXR8ZW58MHx8fHwxNzgyOTAzOTE3fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "birthday",
    name: "Birthday Hampers",
    tagline: "Joyful moments, elegantly wrapped",
    description:
      "Premium halal birthday hampers with gourmet chocolates, teas, and beautifully wrapped treats for loved ones of every age.",
    image: "https://images.unsplash.com/photo-1610377507996-dcd4f0cfc125?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwzfHx3ZWRkaW5nJTIwZ2lmdCUyMGVsZWdhbnR8ZW58MHx8fHwxNzgyOTAzOTE4fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "business-opening",
    name: "Business Opening Hampers",
    tagline: "Prosperity for new beginnings",
    description:
      "Grand opening halal hampers to congratulate business milestones — prosperous, premium and thoughtfully curated.",
    image: "https://images.unsplash.com/photo-1625552185153-7a8d8f3794a3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwyfHxjb3Jwb3JhdGUlMjBnaWZ0JTIwYm94fGVufDB8fHx8MTc4MjkwMzkxN3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "corporate",
    name: "Corporate Gifts",
    tagline: "Refined gifting for clients & teams",
    description:
      "Bulk-friendly halal corporate hampers for clients, partners and staff — brand-aligned, premium and delivered across Singapore.",
    image: "https://images.pexels.com/photos/20699855/pexels-photo-20699855.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    slug: "festive",
    name: "Hari Raya Hampers",
    tagline: "Celebrate the season with grace",
    description:
      "Festive Hari Raya and Ramadan halal gift hampers filled with dates, kueh, treats and elegant keepsakes.",
    image: "https://images.unsplash.com/photo-1711645973555-d03091cc4d0a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxyYW1hZGFuJTIwZ2lmdCUyMGhhbXBlcnxlbnwwfHx8fDE3ODI5MDM5MzZ8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "get-well",
    name: "Get Well Soon",
    tagline: "Warm wishes for a swift recovery",
    description:
      "Comforting halal-friendly hampers with wholesome treats, teas and thoughtful touches to lift spirits.",
    image: "https://images.unsplash.com/photo-1770989064308-78baffbaa47e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBnaWZ0JTIwaGFtcGVyfGVufDB8fHx8MTc4MjkwMzkxN3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "custom",
    name: "Custom Gift Hampers",
    tagline: "Curated to your occasion",
    description:
      "Bespoke halal gift hampers designed around your budget, occasion, and recipient preferences.",
    image: "https://images.unsplash.com/photo-1773450970959-cef81e9b1053?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBnaWZ0JTIwaGFtcGVyfGVufDB8fHx8MTc4MjkwMzkxN3ww&ixlib=rb-4.1.0&q=85",
  },
];

export const SHOP_CATEGORIES = [
  ...CATEGORIES,
  { slug: "thank-you", name: "Thank You Hampers", tagline: "Gratitude in every detail", description: "Say thank you with premium halal treats.", image: "https://images.pexels.com/photos/27393960/pexels-photo-27393960.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { slug: "sympathy", name: "Sympathy Hampers", tagline: "Comfort in difficult times", description: "Thoughtful, respectful halal hampers.", image: "https://images.unsplash.com/photo-1610377507996-dcd4f0cfc125?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwzfHx3ZWRkaW5nJTIwZ2lmdCUyMGVsZWdhbnR8ZW58MHx8fHwxNzgyOTAzOTE4fDA&ixlib=rb-4.1.0&q=85" },
  { slug: "graduation", name: "Graduation Hampers", tagline: "Celebrate achievements", description: "Premium halal hampers to honour milestones.", image: "https://images.unsplash.com/photo-1770989064308-78baffbaa47e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBnaWZ0JTIwaGFtcGVyfGVufDB8fHx8MTc4MjkwMzkxN3ww&ixlib=rb-4.1.0&q=85" },
];

const HAMPER_IMAGES = [
  "https://images.pexels.com/photos/27393960/pexels-photo-27393960.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/20699855/pexels-photo-20699855.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.unsplash.com/photo-1770989064308-78baffbaa47e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBnaWZ0JTIwaGFtcGVyfGVufDB8fHx8MTc4MjkwMzkxN3ww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1773450970959-cef81e9b1053?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBnaWZ0JTIwaGFtcGVyfGVufDB8fHx8MTc4MjkwMzkxN3ww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1610377507996-dcd4f0cfc125?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwzfHx3ZWRkaW5nJTIwZ2lmdCUyMGVsZWdhbnR8ZW58MHx8fHwxNzgyOTAzOTE4fDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1711645973621-fc4929ed9d5a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxyYW1hZGFuJTIwZ2lmdCUyMGhhbXBlcnxlbnwwfHx8fDE3ODI5MDM5MzZ8MA&ixlib=rb-4.1.0&q=85",
];

export const PRODUCTS = [
  {
    id: "p-001",
    sku: "HGH-WED-001",
    name: "Premium Wedding Hamper",
    slug: "premium-wedding-hamper",
    category: "wedding",
    price: 268,
    discountPrice: 238,
    stock: 12,
    featured: true,
    bestSeller: true,
    shortDesc: "A luxurious wedding hamper with premium chocolates, dates, dry fruits and elegant keepsakes.",
    description:
      "Celebrate a beautiful union with our Premium Wedding Hamper — a curated selection of the finest halal-friendly treats, presented in a signature gift box with silk ribbon. Ideal for weddings, engagements, and akad nikah gifting.",
    items: [
      "Premium Ajwa dates 500g",
      "Belgian halal-friendly chocolate assortment",
      "Assorted mixed nuts & dry fruits",
      "Rose-flavoured Turkish delights",
      "Gourmet halal cookies",
      "Elegant gift box with silk ribbon",
    ],
    images: [HAMPER_IMAGES[0], HAMPER_IMAGES[2], HAMPER_IMAGES[3], HAMPER_IMAGES[4]],
  },
  {
    id: "p-002",
    sku: "HGH-NEW-002",
    name: "Newborn Blessings Hamper",
    slug: "newborn-blessings-hamper",
    category: "newborn",
    price: 168,
    discountPrice: null,
    stock: 20,
    featured: true,
    bestSeller: false,
    shortDesc: "Soft essentials, gentle treats and keepsakes for new parents and baby.",
    description:
      "A warm welcome for the newest arrival — soft baby essentials paired with gentle halal-friendly treats for parents, presented with a handwritten congratulations card.",
    items: [
      "Organic baby cotton wrap",
      "Muslin swaddle set",
      "Gentle baby toiletries",
      "Halal-friendly herbal tea for mum",
      "Assorted date bites",
      "Congratulations keepsake card",
    ],
    images: [HAMPER_IMAGES[2], HAMPER_IMAGES[3], HAMPER_IMAGES[0]],
  },
  {
    id: "p-003",
    sku: "HGH-BDY-003",
    name: "Birthday Joy Hamper",
    slug: "birthday-joy-hamper",
    category: "birthday",
    price: 148,
    discountPrice: 128,
    stock: 4,
    featured: true,
    bestSeller: true,
    shortDesc: "Gourmet chocolates, artisan cookies and celebration treats.",
    description:
      "Make their day unforgettable with a hamper packed with gourmet chocolates, artisan cookies and premium halal-friendly celebration treats.",
    items: [
      "Assorted premium chocolates",
      "Artisan butter cookies",
      "Gourmet halal marshmallows",
      "Sparkling non-alcoholic beverage",
      "Birthday keepsake candle",
    ],
    images: [HAMPER_IMAGES[3], HAMPER_IMAGES[4], HAMPER_IMAGES[1]],
  },
  {
    id: "p-004",
    sku: "HGH-BIZ-004",
    name: "Grand Opening Prosperity Hamper",
    slug: "grand-opening-prosperity-hamper",
    category: "business-opening",
    price: 328,
    discountPrice: null,
    stock: 8,
    featured: true,
    bestSeller: false,
    shortDesc: "A statement hamper to congratulate business openings and milestones.",
    description:
      "Congratulate new ventures with a statement halal gift hamper — filled with premium treats, a keepsake plaque option, and elegant presentation suited for business openings.",
    items: [
      "Premium Ajwa dates",
      "Luxury halal chocolate box",
      "Gourmet mixed nuts",
      "Premium honey selection",
      "Prosperity keepsake plaque (optional)",
      "Grand opening card",
    ],
    images: [HAMPER_IMAGES[1], HAMPER_IMAGES[0], HAMPER_IMAGES[5]],
  },
  {
    id: "p-005",
    sku: "HGH-COR-005",
    name: "Corporate Appreciation Hamper",
    slug: "corporate-appreciation-hamper",
    category: "corporate",
    price: 188,
    discountPrice: 168,
    stock: 40,
    featured: true,
    bestSeller: true,
    shortDesc: "Refined corporate hamper for clients, partners and staff — bulk-order friendly.",
    description:
      "A polished corporate gifting solution — halal-friendly premium treats presented in a co-brandable gift box. Ideal for client appreciation, staff recognition and event gifting.",
    items: [
      "Gourmet halal chocolate assortment",
      "Premium teas & French cookies",
      "Roasted nuts selection",
      "Branded card slot (optional)",
      "Refined gift box",
    ],
    images: [HAMPER_IMAGES[1], HAMPER_IMAGES[2], HAMPER_IMAGES[3]],
  },
  {
    id: "p-006",
    sku: "HGH-RAY-006",
    name: "Hari Raya Celebration Hamper",
    slug: "hari-raya-celebration-hamper",
    category: "festive",
    price: 218,
    discountPrice: 188,
    stock: 15,
    featured: true,
    bestSeller: true,
    shortDesc: "Traditional festive treats reimagined for elegant Hari Raya gifting.",
    description:
      "Celebrate Hari Raya and Ramadan with a beautifully curated halal hamper — traditional kueh, premium dates, festive chocolates and heartfelt keepsakes.",
    items: [
      "Premium Medjool dates",
      "Assorted traditional kueh selection",
      "Festive chocolate box",
      "Rose syrup gift set",
      "Elegant Hari Raya card",
    ],
    images: [HAMPER_IMAGES[5], HAMPER_IMAGES[0], HAMPER_IMAGES[4]],
  },
  {
    id: "p-007",
    sku: "HGH-GWS-007",
    name: "Warm Wishes Get Well Hamper",
    slug: "warm-wishes-get-well-hamper",
    category: "get-well",
    price: 128,
    discountPrice: null,
    stock: 18,
    featured: false,
    bestSeller: false,
    shortDesc: "Comforting halal treats and gentle wellness essentials.",
    description:
      "Send warm wishes with a comforting halal-friendly hamper — soothing herbal teas, wholesome snacks and thoughtful essentials for a swift recovery.",
    items: [
      "Halal-friendly herbal tea assortment",
      "Wholesome date & nut bites",
      "Honey selection",
      "Soft comfort throw",
      "Handwritten wellness card",
    ],
    images: [HAMPER_IMAGES[2], HAMPER_IMAGES[3]],
  },
  {
    id: "p-008",
    sku: "HGH-CUS-008",
    name: "Signature Custom Hamper",
    slug: "signature-custom-hamper",
    category: "custom",
    price: 248,
    discountPrice: null,
    stock: 99,
    featured: false,
    bestSeller: false,
    shortDesc: "Fully custom halal hamper curated around your occasion.",
    description:
      "Tell us your occasion, budget and recipient preferences — we'll curate a bespoke halal gift hamper tailored to your story.",
    items: ["Fully customisable contents", "Choice of gift box", "Personalised card", "Optional add-ons"],
    images: [HAMPER_IMAGES[3], HAMPER_IMAGES[4]],
  },
  {
    id: "p-009",
    sku: "HGH-WED-009",
    name: "Rose & Gold Wedding Hamper",
    slug: "rose-gold-wedding-hamper",
    category: "wedding",
    price: 348,
    discountPrice: 298,
    stock: 6,
    featured: false,
    bestSeller: false,
    shortDesc: "A rose-scented, gold-accented luxury wedding hamper.",
    description:
      "An exquisite wedding hamper accented in rose and gold — for couples who want to gift or receive nothing short of extraordinary.",
    items: ["Rose Turkish delights", "Gold-dusted chocolates", "Premium Ajwa dates", "Rose water gift set", "Luxury gift box"],
    images: [HAMPER_IMAGES[4], HAMPER_IMAGES[0]],
  },
  {
    id: "p-010",
    sku: "HGH-COR-010",
    name: "Executive Corporate Hamper",
    slug: "executive-corporate-hamper",
    category: "corporate",
    price: 298,
    discountPrice: null,
    stock: 25,
    featured: false,
    bestSeller: false,
    shortDesc: "An executive-tier halal corporate hamper for VIP clients.",
    description:
      "Executive corporate gifting done right — premium halal treats, gourmet coffee/tea pairings, all presented in a bespoke gift box.",
    items: ["Gourmet halal chocolates", "Premium coffee & tea set", "Roasted nut collection", "Executive card slot"],
    images: [HAMPER_IMAGES[1], HAMPER_IMAGES[5]],
  },
  {
    id: "p-011",
    sku: "HGH-BDY-011",
    name: "Sweet Celebration Birthday Hamper",
    slug: "sweet-celebration-birthday-hamper",
    category: "birthday",
    price: 118,
    discountPrice: null,
    stock: 22,
    featured: false,
    bestSeller: false,
    shortDesc: "A joyful birthday hamper full of sweet halal treats.",
    description:
      "A cheerful halal birthday hamper packed with chocolates, cookies and small delights — perfect for friends, family and kids.",
    items: ["Chocolate selection", "Butter cookies", "Marshmallow pouch", "Birthday card"],
    images: [HAMPER_IMAGES[3], HAMPER_IMAGES[2]],
  },
  {
    id: "p-012",
    sku: "HGH-RAY-012",
    name: "Ramadan Elegance Hamper",
    slug: "ramadan-elegance-hamper",
    category: "festive",
    price: 258,
    discountPrice: null,
    stock: 10,
    featured: false,
    bestSeller: false,
    shortDesc: "A festive Ramadan hamper with premium dates and treats.",
    description:
      "Bring elegance to Ramadan gifting with premium Medjool dates, festive chocolates and traditional treats presented in a signature box.",
    items: ["Medjool dates", "Festive chocolates", "Rose syrup", "Ramadan card"],
    images: [HAMPER_IMAGES[5], HAMPER_IMAGES[4]],
  },
];

export const TESTIMONIALS = [
  {
    name: "Nadia S.",
    role: "Bride, Bukit Timah",
    text: "The wedding hampers were absolutely stunning. Every guest complimented the presentation — truly premium and elegant.",
  },
  {
    name: "Rahim & Co.",
    role: "Corporate Client",
    text: "Ordered 120 hampers for our client appreciation event. Delivery was seamless across Singapore and the quality was exceptional.",
  },
  {
    name: "Aisyah M.",
    role: "New Mum, Punggol",
    text: "Received a newborn hamper as a gift — everything was thoughtfully halal-friendly and beautifully wrapped. Highly recommended.",
  },
  {
    name: "Fadhil H.",
    role: "Business Owner",
    text: "Their grand opening hamper made a lasting impression at our launch. Elegant, timely, and worth every dollar.",
  },
];

export const FAQ_CATEGORIES = [
  {
    heading: "Ordering",
    items: [
      {
        q: "How do I place an order?",
        a: "You can order directly through our website by adding hampers to your cart and completing checkout, or reach out via WhatsApp for a personalised recommendation.",
      },
      {
        q: "Can I customise my hamper?",
        a: "Absolutely. We offer fully custom hampers tailored to your occasion, budget, and recipient preferences. Contact us via WhatsApp to start curating.",
      },
      {
        q: "Can I add a gift message?",
        a: "Yes, every order allows you to include a personalised gift message at checkout — handwritten on a premium keepsake card.",
      },
    ],
  },
  {
    heading: "Delivery",
    items: [
      { q: "Do you deliver across Singapore?", a: "Yes, we deliver islandwide across Singapore, including all residential and commercial addresses." },
      { q: "Can I choose a delivery date?", a: "Yes, you can select your preferred delivery date and time slot during checkout." },
      { q: "How do I check delivery status?", a: "Once your order is dispatched, you'll receive delivery status updates via WhatsApp or email." },
    ],
  },
  {
    heading: "Payment",
    items: [
      { q: "What payment methods are accepted?", a: "We accept major credit/debit cards, PayNow, and secure online payments via HitPay or Stripe." },
      { q: "Can I use promo codes?", a: "Yes, apply your promo code at the cart or checkout page to receive an instant discount." },
    ],
  },
  {
    heading: "Halal Gifts",
    items: [
      { q: "Are the hampers suitable for Muslim recipients?", a: "All our hampers are guaranteed of halal-compliant products and suitable for everyone." },
      { q: "Are the items halal-friendly?", a: "We carefully source halal-friendly items. Any non-food additions are clearly indicated on the product page." },
    ],
  },
  {
    heading: "Returns & Refunds",
    items: [
      { q: "Can I cancel my order?", a: "Yes. Orders can be cancelled up to 24 hours before your scheduled delivery date. Once cancelled, your refund is processed back to the original payment method and typically takes 5–10 business days to appear." },
      { q: "What if my hamper arrives damaged?", a: "We're sorry if anything arrives less than perfect. Please report it within 24 hours of delivery with a few photos of the hamper and the affected items, and we'll arrange a replacement or a full refund straight away." },
      { q: "Can I return food items?", a: "For hygiene and food-safety reasons, perishable and food items cannot be returned unless they arrive damaged or incorrect. In those cases we'll replace the item or refund you to your original payment method within 5–10 business days." },
    ],
  },
  {
    heading: "Order Tracking",
    items: [
      { q: "How do I check my order status?", a: "Visit our Track Order page at /track and enter your order number together with the email address used at checkout to see exactly where your hamper is." },
      { q: "What do the delivery statuses mean?", a: "Every order moves through Pending, Preparing, Packed, Ready for Dispatch, Out for Delivery, Delivered and finally Completed — so you always know which stage your hamper has reached." },
      { q: "Will I be notified about my order?", a: "Yes. Automated emails are sent when your order is confirmed, when your payment is confirmed, when your hamper is being prepared, and again on delivery." },
    ],
  },
];

export const WHY_CHOOSE_US = [
  { icon: "BadgeCheck", title: "Halal-Friendly Selections", text: "Thoughtfully curated with halal-friendly items suitable for Muslim recipients." },
  { icon: "Gift", title: "Premium Presentation", text: "Elegant gift boxes, silk ribbons and thoughtful details in every hamper." },
  { icon: "Moon", title: "Suitable for Muslim Recipients", text: "Ideal for weddings, Hari Raya, akikah and festive gifting." },
  { icon: "Truck", title: "Islandwide Singapore Delivery", text: "Reliable delivery across Singapore with preferred date selection." },
  { icon: "Sparkles", title: "Customisable Hampers", text: "Bespoke curation around your occasion, budget and preferences." },
  { icon: "Briefcase", title: "Personal & Corporate", text: "Perfect for individuals, families and businesses of every size." },
];

// Admin mock data
export const ADMIN_STATS = {
  totalOrders: 1284,
  totalSales: 268430,
  pendingDeliveries: 42,
  lowStockProducts: 6,
  activePromoCodes: 4,
};

export const MOCK_ORDERS = [
  { id: "HGH-24118", customer: "Nadia Salim", recipient: "Kak Aminah", total: 268, payment: "Paid", delivery: "Delivered", date: "2025-12-01" },
  { id: "HGH-24119", customer: "Rahim & Co.", recipient: "TechCore Pte Ltd", total: 22560, payment: "Paid", delivery: "Out for Delivery", date: "2025-12-02" },
  { id: "HGH-24120", customer: "Fadhil Hakim", recipient: "New Horizons Cafe", total: 328, payment: "Pending", delivery: "Preparing", date: "2025-12-03" },
  { id: "HGH-24121", customer: "Aisyah Mohd", recipient: "Baby Zafran", total: 168, payment: "Paid", delivery: "Packed", date: "2025-12-03" },
  { id: "HGH-24122", customer: "Imran Zulkifli", recipient: "Siti Rahmah", total: 188, payment: "Paid", delivery: "Ready for Dispatch", date: "2025-12-04" },
  { id: "HGH-24123", customer: "Global Bank SG", recipient: "Client List (25)", total: 4700, payment: "Paid", delivery: "Pending", date: "2025-12-04" },
];

export const MOCK_PROMO_CODES = [
  { code: "RAYA25", type: "Percentage", value: 15, minPurchase: 150, maxDiscount: 50, usageLimit: 200, perCustomer: 1, start: "2025-11-15", end: "2026-04-30", active: true },
  { code: "WELCOME10", type: "Percentage", value: 10, minPurchase: 100, maxDiscount: 30, usageLimit: 500, perCustomer: 1, start: "2025-01-01", end: "2026-12-31", active: true },
  { code: "CORP100", type: "Fixed Amount", value: 100, minPurchase: 1000, maxDiscount: 100, usageLimit: 100, perCustomer: 3, start: "2025-06-01", end: "2026-06-30", active: true },
  { code: "WEDDING20", type: "Percentage", value: 20, minPurchase: 250, maxDiscount: 80, usageLimit: 150, perCustomer: 1, start: "2025-01-01", end: "2026-12-31", active: false },
];

export const DELIVERY_STATUSES = [
  "Pending",
  "Preparing",
  "Packed",
  "Ready for Dispatch",
  "Out for Delivery",
  "Delivered",
  "Completed",
  "Cancelled",
];

export const formatSGD = (n) =>
  new Intl.NumberFormat("en-SG", { style: "currency", currency: "SGD", minimumFractionDigits: 2 }).format(n);
